import React from 'react';
import AdminTrackRecords from "../../components/admin/components/AdminTrackRecords";

const Tracking = () => {
    return <AdminTrackRecords />;
};

export default Tracking;
